import Human from "./human.js";

var obj = new Human('Webpacker');
obj.hello();



// WEBPACK FOOTER //
// ./app/javascript/packs/application.js